export const getAbsencesStatus = (state) => state.status
export const getAbsences = (state) => state.holidays
export const userCountryWorkdaysList = (state) => state.userWorkdays
export const userCountryPublicHolidaysList = (state) => state.userPublicHolidays
export const getManageAbsences = (state) => state.manage_absences
export const getSocietyHolidaysByOffice = (state) => state.societyHolidaysByOffice
export const getSocietyOfficesHolidays = (state) => state.societyOffices
export const getUsersHolidays = (state) => state.usersHolidays